module.exports = __webpack_public_path__ + "img/info.18691fc0.svg";